interface SubscriptionStateModal {
   unknown: string;
   inactive: string;
   active: string;
}

const subscriptionStates: SubscriptionStateModal = {
   unknown: 'unknown',
   inactive: 'inactive',
   active: 'active'
};

export default subscriptionStates;
